<template>
  <div class="userAuditStatus">
    <!--header-->
    <HeaderNav title="注册详情"></HeaderNav>
    <!-- content -->
    <a-row class="content">
      <div class="table">
        <a-table
          :pagination="false"
          :columns="columns"
          :dataSource="dataSource"
          :rowKey="(record) => record.id"
        >
          <template slot="creationTime" slot-scope="text">
            {{ dayjs(text).format("YYYY-MM-DD") }}
          </template>
          <template slot="auditStatus" slot-scope="text">
            <span style="color: gray" v-if="text === null">待审核</span>
            <span style="color: green" v-if="text === '1'">通过</span>
            <span style="color: red" v-if="text === '2'">未通过</span>
          </template>
          <template slot="operation" slot-scope="text, record">
            <a-button
              size="small"
              @click="reRegister(record)"
              v-if="record.auditStatus === '2'"
              >重新发起审核</a-button
            >
            <div v-else>-</div>
          </template>
        </a-table>
      </div>
    </a-row>
    <!-- 底部 -->
    <FooterNav class="footerNav"></FooterNav>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { SqliteUserAuditGet } from '@/api/Sqlite'
import { A_TENANT_ID, A_ACCESS_TOKEN, USER_USERNAME } from '@/store/mutation-types'
import HeaderNav from '@/components/HeaderNav'
import FooterNav from '@/components/FooterNav'

const columns = [
  {
    title: '用户名',
    dataIndex: 'userName',
    key: 'userName'
  },
  {
    title: '审核状态',
    dataIndex: 'auditStatus',
    key: 'auditStatus',
    scopedSlots: { customRender: 'auditStatus' }
  },
  {
    title: '原因',
    dataIndex: 'reason',
    key: 'reason',
    scopedSlots: { customRender: 'reason' }
  },
  {
    title: '备注',
    dataIndex: 'remark',
    key: 'remark',
    scopedSlots: { customRender: 'remark' }
  },
  {
    title: '创建时间',
    dataIndex: 'creationTime',
    key: 'creationTime',
    scopedSlots: { customRender: 'creationTime' }
  },
  {
    title: '操作',
    dataIndex: 'operation',
    key: 'operation',
    scopedSlots: { customRender: 'operation' }
  }
]

export default {
  name: 'userAuditStatus',
  components: { HeaderNav, FooterNav },
  data () {
    return {
      dayjs,
      columns,
      dataSource: []
    }
  },
  async created () {
    const aToken = this.$ls.get(A_ACCESS_TOKEN)
    const tenant = this.$ls.get(A_TENANT_ID)
    const username = this.$ls.get(USER_USERNAME)
    await this.getAUserInfo(aToken, tenant, username)

    // this.dataSource = [data];
  },
  methods: {
    // 获取A用户信息
    async getAUserInfo (aToken, tenant, username) {
      const auserData = await SqliteUserAuditGet(
        { filter: `userName == "${username}"` },
        {
          'Abp.TenantId': tenant,
          Authorization: `Bearer ${aToken}`
        }
      )
      this.dataSource = auserData.result.items
    },

    // 重新发起审核
    reRegister (record) {
      console.log(this.$confirm)
      this.$confirm({
        content: '是否重新发起审核？',
        onOk: async () => {
          this.$router.push({
            name: 'reRegister',
            params: {
              platform: this.$route.params.platform,
              userName: record.userName
            }
          })
        },
        onCancel: () => {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
.userAuditStatus {
  min-height: 100vh;
  .content {
    background: #f7f7f8;
    padding: 20px;
    min-width: 1220px;
    .table {
      min-height: calc(100vh - 280px);
      background: white;
      padding: 40px;
    }
  }
}
</style>
